import {sumBy} from 'lodash';
import {isNullOrUndefined} from 'util';
import {SelectedInvestment} from './selected-investment.model';

export class SelectedInvestments extends Array<SelectedInvestment> {
    private constructor() {
        super();
    }

    public static empty(): SelectedInvestments {
        return Object.create(SelectedInvestments.prototype);
    }

    public static from(selectedInvestmentsJson: any): SelectedInvestments {
        if (isNullOrUndefined(selectedInvestmentsJson)) {
            return selectedInvestmentsJson;
        }
        const selectedInvestments = SelectedInvestments.empty();
        Array.from(selectedInvestmentsJson).forEach(investment =>
            selectedInvestments.push(SelectedInvestment.from(investment as SelectedInvestment)));
        return selectedInvestments;
    }

    public allocatedAmount(): number {
        return sumBy(this, investment => investment.amount);
    }

    public findAmountInvestedInLoan(loanId: string): number {
        const selectedInvestment = this.find(item => item.gaugedInvestment.loan._id === loanId);
        return selectedInvestment ? selectedInvestment.amount : 0;
    }
}